var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { style: _vm.boxStyle }, [
        _c("div", { staticClass: "diy-store-card" }, [
          _c("div", { staticClass: "store-body" }, [
            _vm._m(0),
            _c("div", { staticClass: "store-info" }, [
              _c("div", { staticClass: "store-name" }, [
                _vm._v(
                  _vm._s(_vm.JavaMerchantConfigInfo.name || "crmeb旗舰店")
                ),
              ]),
              _c("div", { staticClass: "store-tags" }, [
                _c("span", { staticClass: "tag" }, [_vm._v("官方旗舰店")]),
                _vm.JavaMerchantBaseInfo.merType
                  ? _c("span", { staticClass: "tag" }, [
                      _vm._v(_vm._s(_vm.JavaMerchantBaseInfo.merType)),
                    ])
                  : _vm._e(),
                _c("span", { staticClass: "tag" }, [_vm._v("保证金¥10万")]),
              ]),
            ]),
            _c("div", { staticClass: "follow-btn" }, [
              _c("span", { staticClass: "follow-label" }, [
                _vm._v(
                  _vm._s(_vm.JavaMerchantBaseInfo.isCollect ? "已关注" : "关注")
                ),
              ]),
              _c("span", { staticClass: "follow-count" }, [_vm._v("12.8w")]),
            ]),
          ]),
          _vm._m(1),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "store-badge" }, [
      _c("span", { staticClass: "badge-text" }, [_vm._v("福")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "store-stats" }, [
      _c("div", { staticClass: "stat-item" }, [
        _c("span", { staticClass: "stat-num" }, [_vm._v("86")]),
        _c("span", { staticClass: "stat-txt" }, [_vm._v("商品")]),
      ]),
      _c("div", { staticClass: "stat-item" }, [
        _c("span", { staticClass: "stat-num" }, [_vm._v("12.8w")]),
        _c("span", { staticClass: "stat-txt" }, [_vm._v("粉丝")]),
      ]),
      _c("div", { staticClass: "stat-item" }, [
        _c("span", { staticClass: "stat-num" }, [_vm._v("4.9")]),
        _c("span", { staticClass: "stat-txt" }, [_vm._v("评分")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }